function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useShoppingSummaryItinerary, useItineraryData } from '@edreamsodigeo/frontend-checkout';
import { useUser } from '@edreamsodigeo/frontend-user-authentication';
import { HotelDealsMobileCardContainerMeta, LoginProvider } from '@edreamsodigeo/frontend-prebooking-attract';
import { getOdigeoSessionValue } from '../../../../boundaries/flow/getOdigeoSessionValue';
export const MetaHotelDealsMobileCardWrapper = () => {
  const loginProps = useUser();
  const {
    data: shoppingSummaryItineraryData,
    loading: shoppingSummaryItineraryLoading
  } = useShoppingSummaryItinerary();
  const itineraryData = useItineraryData(shoppingSummaryItineraryData === null || shoppingSummaryItineraryData === void 0 ? void 0 : shoppingSummaryItineraryData.products);
  if (shoppingSummaryItineraryLoading || !itineraryData) {
    return null;
  }
  const mktPortal = getOdigeoSessionValue('mktPortal', null);
  return /*#__PURE__*/React.createElement(LoginProvider, {
    loginProps: loginProps
  }, /*#__PURE__*/React.createElement(HotelDealsMobileCardContainerMeta, _extends({}, itineraryData, {
    isMeta: true,
    mktPortal: mktPortal,
    totalNumPassengers: shoppingSummaryItineraryData === null || shoppingSummaryItineraryData === void 0 ? void 0 : shoppingSummaryItineraryData.totalNumPassengers
  })));
};